import { tsValidateArray, tsValidateBoolean, tsValidateDBPointer, tsValidateDynamicObject, tsValidateIsInRange, tsValidateOptionalId, tsValidateResult, tsValidateString, tsValidateTimeRange, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { PreconditionIndex } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_Action } from '../action/index.js';
import { DBDef_OrderGroup } from '../order-group/index.js';
import { Validator_PathwayStateType } from '../../_enum/pathway-state-type/index.js';
const Validator_TimeConstraint = (instance) => {
    if (!instance)
        return;
    return tsValidateResult(instance, {
        timeRange: tsValidateTimeRange(false),
        index: tsValidateValue(PreconditionIndex)
    });
};
const Validator_ModifiableProps = {
    name: tsValidateString(),
    label: tsValidateString(),
    type: Validator_PathwayStateType,
    pathwayIds: tsValidateArray(tsValidateUniqueId),
    dds: tsValidateArray({ diseaseProfileId: tsValidateUniqueId, probability: tsValidateIsInRange([[0, 1]], false) }),
    logTemplates: tsValidateArray({
        templateId: tsValidateUniqueId,
        aliases: tsValidateDynamicObject(tsValidateString(), tsValidateString(), false)
    }, false),
    preconditions: tsValidateArray({
        itemPointer: tsValidateDBPointer([DBDef_Action, DBDef_OrderGroup]),
        timeConstraint: Validator_TimeConstraint,
        expressionId: tsValidateOptionalId
    }, false),
    expressionIds: tsValidateArray(tsValidateUniqueId, false),
    expressionV2Ids: tsValidateArray(tsValidateUniqueId, false),
    initial: tsValidateBoolean(false),
    ignoreDocumentation: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {
    __orderIds: tsValidateArray(tsValidateUniqueId),
    __orderGroupIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_PathwayState = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['__orderIds', '__orderGroupIds'],
    versions: ['1.0.7', '1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'pathway-states',
    entityName: 'PathwayState',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'pathway-state'
    },
    backend: {
        name: 'pathway-states'
    },
    dependencies: {
        'pathwayIds': {
            dbKey: 'pathway',
            fieldType: 'string[]'
        },
        'expressionIds': {
            dbKey: 'expressions',
            fieldType: 'string[]'
        },
        '__orderIds': {
            dbKey: 'orders',
            fieldType: 'string[]'
        },
        '__orderGroupIds': {
            dbKey: DBDef_OrderGroup.dbKey,
            fieldType: 'string[]',
        },
        'expressionV2Ids': {
            dbKey: 'expressions',
            fieldType: 'string[]'
        },
    }
};
//# sourceMappingURL=db-def.js.map